import React, { createContext, useState } from "react";

export const ConfirmationContext = createContext();

export const ConfirmationProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [prompt, setPrompt] = useState(null);
  const [onCancel, setOnCancel] = useState(null);
  const [onConfirm, setOnConfirm] = useState(null);

  const showConfirmation = ({
    prompt: newPrompt,
    onCancel: newOnCancel,
    onConfirm: newOnConfirm,
  }) => {
    setPrompt(newPrompt);
    setIsVisible(true);

    setOnCancel(() => () => {
      if (newOnCancel) {
        newOnCancel();
      }

      setIsVisible(false);
    });

    setOnConfirm(() => () => {
      if (newOnConfirm) {
        newOnConfirm();
      }

      setIsVisible(false);
    });
  };

  return (
    <ConfirmationContext.Provider
      value={{ isVisible, prompt, onCancel, onConfirm, showConfirmation }}
    >
      {children}
    </ConfirmationContext.Provider>
  );
};
